<template>
  <div class="about_alliances" style="min-width:1440px;">
    <div class="second_banner animated fadeIn">
      <!-- <img class="banner_img" src="../assets/img/union_banner.png" alt /> -->
      <img class="banner_img" :src="img.data.data.url" alt />
    </div>
    <div class="second_main animated fadeInUp" style="font-size:20px;padding-left:20%;padding-right:20%">
        <div  style="color:#2A303C;margin-bottom:80px">
            <div v-if="chOrEn!='0'"  style="display: flex;justify-content: flex-start;align-items:center;">
                <!-- <div id="pointer" style="cursor:pointer;" @click="go">展览交流</div>
                <div id="before"> </div>
                <div id="pointers"  style="margin-left:10px;cursor:pointer;">详情</div>
                <div id="before"> </div>
                <div id="after"> </div>
                <div id="pointerss" style="margin-left:10px"></div>
                <div id="before"> </div>
                <div id="after"> </div>
                <div id="pointersss" style="margin-left:10px"></div>
                <div id="before"> </div>
                <div id="after"> </div>
                <div id="pointerssss" style="margin-left:10px"></div>
                <div id="before"> </div>
                <div id="after"> </div> -->
                <!-- <span @click="gos" style="cursor:pointer;">首页</span>
                <span><i class="el-icon-arrow-right"></i></span> -->
                <i class="el-icon-caret-right" style="font-size:24px;color:#24367D"></i>
                <span @click="go" style="cursor:pointer;color:#24367D;font-weight: bold;">展览交流</span>  
                <span><i class="el-icon-arrow-right"></i></span>
                <span style="color:#24367D;font-weight: bold;">详情</span>
            </div>
            <div v-else style="display: flex;justify-content: flex-start;align-items:center;">
                <i class="el-icon-caret-right" style="font-size:24px;color:#24367D"></i>
                <span @click="go" style="cursor:pointer;color:#24367D;font-weight: bold;">Exhibition & Communication</span>  
                <span><i class="el-icon-arrow-right"></i></span>
                <span style="color:#24367D;font-weight: bold;">Detail</span>
                <!-- <div id="pointer" @click="go">Exhibition & Communication</div>
                <div id="before"> </div>
                <div id="pointers" style="margin-left:10px">Detail</div>
                <div id="before"> </div>
                <div id="after"> </div>
                <div id="pointerss" style="margin-left:10px"></div>
                <div id="before"> </div>
                <div id="after"> </div>
                <div id="pointersss" style="margin-left:10px"></div>
                <div id="before"> </div>
                <div id="after"> </div>
                <div id="pointerssss" style="margin-left:10px"></div>
                <div id="before"> </div>
                <div id="after"> </div> -->
            </div>          
            
            <!-- <svg t="1608204057417" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1154" width="50" height="50"><path d="M522.098 825.237L100.015 512.978l425.313-311.415-1.134 219.033-63.999-0.34 0.476-92.029-252.686 185.017 250.767 185.52 0.483-93.125 63.999 0.332z" fill="" p-id="1155"></path><path d="M927.996 895.639l-78.278-94.295c-1.197-1.439-121.436-145.06-219.643-174.439-69.697-20.852-114.845-15.182-135.555-9.947-6.043 1.528-9.195 2.856-9.249 2.879 0.278-0.119 0.416-0.188 0.416-0.188l-26.283-55.152c1.749-0.809 8.34-3.67 19.736-6.551 26.979-6.82 84.795-14.502 168.914 10.664 55.892 16.72 114.489 60.758 160.868 102.699-23.124-61.906-58.291-131.924-106.667-165.366-50.304-34.774-108.331-48.518-148.151-53.924-44.252-6.006-76.694-3.377-77.017-3.35l-5.46-60.687c6.071-0.535 150.03-12.189 266.165 68.095 50.1 34.633 93.374 99.532 128.62 192.895 25.459 67.437 37.108 124.773 37.591 127.181l23.993 119.486z" fill="" p-id="1156"></path><path d="M458.909 320.962l64-0.333 0.667 128.214-64 0.333zM459.204 564.498h63.874v52.169h-63.874z" fill="" p-id="1157"></path></svg> -->
        </div>
        <!-- <div  style="color:rgb(28, 72, 127);margin-bottom:80px">
            <div v-if="chOrEn!='0'"  style="display: flex;justify-content: flex-start;align-items:center;">
            <div id="pointer" style="cursor:pointer;" @click="go">展览交流</div>
            <div id="before"> </div>
            <div id="pointers"  style="margin-left:10px;cursor:pointer;">详情</div>
            <div id="before"> </div>
            <div id="after"> </div>
            <div id="pointerss" style="margin-left:10px"></div>
            <div id="before"> </div>
            <div id="after"> </div>
            <div id="pointersss" style="margin-left:10px"></div>
            <div id="before"> </div>
            <div id="after"> </div>
            <div id="pointerssss" style="margin-left:10px"></div>
            <div id="before"> </div>
            <div id="after"> </div>
            </div>
            <div v-else style="display: flex;justify-content: flex-start;align-items:center;">
                <div id="pointer" @click="go">Exhibition & Communication</div>
                <div id="before"> </div>
                <div id="pointers" style="margin-left:10px">Detail</div>
                <div id="before"> </div>
                <div id="after"> </div>
                <div id="pointerss" style="margin-left:10px"></div>
                <div id="before"> </div>
                <div id="after"> </div>
                <div id="pointersss" style="margin-left:10px"></div>
                <div id="before"> </div>
                <div id="after"> </div>
                <div id="pointerssss" style="margin-left:10px"></div>
                <div id="before"> </div>
                <div id="after"> </div>
            </div>          
        </div> -->
      <el-tabs tab-position="left">
          <p></p>
          <div class="datail">
          <div v-html="title">{{title}}</div>
          </div>
            <!-- <div class="meeting_content">
                <h2>雕塑公园国际联盟暨殷小烽雕塑展在长春世界雕塑园成功举办</h2>
                <div class="media_video">
                    <video-player
                        class="video-player vjs-custom-skin"
                        ref="videoPlayer"
                        :playsinline="true"
                        :options="playerOptions"
                    ></video-player>
                </div>
                <div class="three_imgs">
                    <div class="img_box">
                        <img src="../assets/img/meeting12.jpg" alt="">
                    </div>
                    <div class="img_box">
                        <img src="../assets/img/meeting13.png" alt="">
                    </div>
                    <div class="img_box">
                        <img src="../assets/img/meeting14.png" alt="">
                    </div>
                </div>
                <p>2016年1月11日，雕塑公园国际联盟暨殷小烽雕塑展在长春世界雕塑园开幕，会议为期两天。本次活动由长春市人民政府、中国城市雕塑家协会主办，由长春世界雕塑园承办，是我市雕塑文化建设乃至中国雕塑事业的一次盛会。</p>
                <p>本次大会是雕塑公园国际联盟成立以来的首次活动。雕塑公园国际联盟是长春世界雕塑园联合瑞士圣乌尔班雕塑公园、意大利基安蒂雕塑公园、法国贝丁顿雕塑花园、拉脱维亚佩德维尔露天雕塑博物馆共同发起，于2014年9月成立的一个无期限组织。长春世界雕塑园是联盟的首任轮值主席单位，也是雕塑公园国际联盟第一次工作会议的承办单位。</p>
                <p>11日10时30分，雕塑公园国际联盟暨殷小烽雕塑展开幕式在长春雕塑艺术馆举行，仪式由邹德东秘书长主持，原建设部副部长宋春华、吉林省政协副主席支建华、长春市人民政府市长姜治莹、雕塑公园国际联盟成员与其他雕塑公园代表以及曾成钢、及云辉、殷小烽等国内知名艺术家出席开幕式。</p>
                <p>开幕式上，长春市副市长白绪贵先生、中国美术家协会副主席曾成钢先生、雕塑公园国际联盟代表格楚女士、著名雕塑家殷小烽先生、东北师范大学校长刘益春先生分别致辞。副市长白绪贵在开幕式上表示，联盟大会在我市召开是对长春雕塑事业发展的肯定。希望通过雕塑公园国际联盟这个平台，进一步促进长春与国际社会的友谊、交流、发展、合作，为联盟成员所在城市开展多元文化互动做出努力。开幕式上，东北师范大学美术学院副院长殷小烽将其创作的14件作品捐献给长春市人民政府，长春市市长姜治莹为殷小烽先生颁发收藏证书，最后宋春华副部长宣布雕塑展开幕。</p>
                <p>11日13时50分，雕塑公园国际联盟第一次工作会议在松山韩蓉非洲艺术收藏博物馆召开。会议由长春城市雕塑学会刘天府副理事长主持。联盟首任主席长春世界雕塑园园长王明山先生首先致辞并做工作总结。会上通过了雕塑公园国际联盟章程。11日15时20分，“共话雕塑公园的未来”研讨会开始。宋春华副部长在会议中做主旨演讲，与会代表逐一发言并对雕塑公园国际联盟的发展前景以及如何进一步扩大联盟影响力等议题进行了热烈的交流与讨论。</p>
                <p>2日10时整，雕塑公园国际联盟大会在松山韩蓉非洲艺术收藏博物馆举行闭幕式，仪式由长春市人民政府（侨务）外事工作办公室徐怀武副主任主持。现任联盟主席长春世界雕塑园园长王明山先生致辞并向本次新入盟的六个成员：美国雕塑庭园、美国苏沃特·强生工作室、台湾朱铭美术馆、美国新奥尔良雕塑公园、波士顿雕塑家艺术馆、美国卡罗尔·富尔曼基金会颁发证书。会上宣布瑞士圣·乌尔班雕塑公园创始人和合伙人格楚女士任下一届联盟主席。11时整，雕塑公园国际联盟第一次工作会议顺利完成了预定的各项议程，为期两天的雕塑公园国际联盟大会正式闭幕。</p>
                <p>在本次雕塑公园国际联盟大会期间，与会代表肩负各自园区的重托，以高度的责任感和主人翁精神，忠实履行职责，共商雕塑联盟发展大计。本次联盟大会的成功举办，必将推动现代雕塑艺术在中国的深入开展，也将成为联系中外雕塑艺术的桥梁与纽带，对中国雕塑事业的发展具有重要意义。</p>
                <h4>长春世界雕塑园</h4>
                <h4>2016年1月13日</h4>
                <div class="three_imgs">
                    <div class="img_box">
                        <img src="../assets/img/meeting15.jpg" alt="">
                    </div>
                    <div class="img_box">
                        <img src="../assets/img/meeting16.jpg" alt="">
                    </div>
                    <div class="img_box">
                        <img src="../assets/img/meeting17.jpg" alt="">
                    </div>
                </div>
                <div class="three_imgs">
                    <div class="img_box">
                        <img src="../assets/img/meeting18.png" alt="">
                    </div>
                    <div class="img_box">
                        <img src="../assets/img/meeting19.jpg" alt="">
                    </div>
                    <div class="img_box">
                        <img src="../assets/img/meeting10.jpg" alt="">
                    </div>
                </div>
                <h2>雕塑公园国际联盟第一次会议决议</h2>
                <p>雕塑（馆）公园国际联盟（以下简称雕塑公园国际联盟）第一次会议于2016年1月11日在中国长春世界雕塑园召开。雕塑公园国际联盟成员和有关雕塑公园代表嘉宾出席了会议。</p>
                <p>雕塑公园国际联盟第一次会议举行了开幕式，原中国住建部副部长宋春华、长春市市长姜治莹及有关方面负责人出席。长春市副市长白绪贵,雕塑公园国际联盟新一届轮值主席、瑞士圣乌尔班雕塑公园创始人格楚·艾希莉曼分别致辞。</p>
                <p>会议听取了首届雕塑公园国际联盟轮值主席、长春世界雕塑园园长王明山所做的工作报告，充分肯定了联盟成立以来卓有成效的工作。</p>
                <p>会议审议通过了《雕塑公园国际联盟章程》；推选瑞士圣乌尔班雕塑公园创始人格楚·艾希莉曼为新一届雕塑公园国际联盟轮值主席。会议一致同意接纳美国雕塑庭园、美国波士顿雕塑家艺术馆、美国新奥尔良雕塑公园、台湾朱铭美术馆等4个雕塑公园为雕塑公园联盟新成员。</p>
                <p>会议举行了《共话雕塑公园未来》的专题研讨，原中国住建部副部长宋春华作了世界雕塑《今日已多姿，明朝更美丽》的主旨演讲；中国长春世界雕塑园园长王明山、美国雕塑庭园执行总监盖里·施耐德、国际雕塑协会董事会成员卡罗尔·富尔曼、台湾朱铭美术馆馆长吴顺令、拉脱维亚佩德尔露天雕塑博物馆劳拉·米格隆、波士顿雕塑家艺术馆艺术家，安迪·莫尔林恩、瑞士圣乌尔班雕塑公园创始人和合伙人，格楚·艾希莉曼、新奥尔良雕塑公园艺术家迈克尔·曼哲瑞思分别就雕塑联盟成员互惠互利、雕塑文化之旅、雕塑公园旅游开发前景、国际联盟与雕塑公园如何共同发展、启动雕塑精品展览、扩大雕塑公园的影响力等进行了专题发言，形成了共识，研究探讨了雕塑公园国际联盟发展大计。</p>
                <p>会议代表还参观考察了长春世界雕塑园、中国著名雕塑家殷小烽作品展和松山韩蓉非洲艺术收藏博物馆。</p>
                <p>会议明确了雕塑公园国际联盟的宗旨是联络世界各地的雕塑公园，促进公园间友好交流、国际合作、健康发展。雕塑公园国际联盟在开展活动时，应充分考虑不同国家的各自特点，尊重不同国家的法律、法规和文化理念。</p>
                <p>会议指出，新一届轮值主席格楚·艾希莉曼在会议结束时的讲话，指明了雕塑公园国际联盟发展方向，希望发挥国际联盟优势，促进雕塑公园健康发展，提出了任期内工作要求，各成员要认真研究落实。</p>
                <p>会议强调，雕塑公园国际联盟成员自觉遵守联盟章程，认真履行成员的职责和义务，结合各自实际完成联盟会议赋予的相关任务。要加强联盟成员之间沟通联系，建设雕塑公园国际联盟网站。积极推荐、鼓励和支持新成员自愿入盟，不断扩大联盟影响力。</p>
                <p>会议要求，加强联盟秘书处工作，建立健全联盟会议及有关工作的规则和制度，确保联盟工作正常开展。</p>
                <p>会议动员雕塑公园国际联盟成员要充分发挥联盟的纽带和桥梁作用，进一步扩大交流、精诚合作、互惠互利、同舟共济，为促进雕塑公园健康发展，繁荣世界雕塑文化做出应有贡献。</p>
            </div> -->
        <!-- <el-tab-pane >
            <div class="meeting_content">
                <h2>雕塑公园国际联盟暨殷小烽雕塑展在长春世界雕塑园成功举办</h2>
                <div class="media_video">
                    <video-player
                        class="video-player vjs-custom-skin"
                        ref="videoPlayer"
                        :playsinline="true"
                        :options="playerOptions"
                    ></video-player>
                </div>
                <div class="three_imgs">
                    <div class="img_box">
                        <img src="../assets/img/meeting12.jpg" alt="">
                    </div>
                    <div class="img_box">
                        <img src="../assets/img/meeting13.png" alt="">
                    </div>
                    <div class="img_box">
                        <img src="../assets/img/meeting14.png" alt="">
                    </div>
                </div>
                <p>2016年1月11日，雕塑公园国际联盟暨殷小烽雕塑展在长春世界雕塑园开幕，会议为期两天。本次活动由长春市人民政府、中国城市雕塑家协会主办，由长春世界雕塑园承办，是我市雕塑文化建设乃至中国雕塑事业的一次盛会。</p>
                <p>本次大会是雕塑公园国际联盟成立以来的首次活动。雕塑公园国际联盟是长春世界雕塑园联合瑞士圣乌尔班雕塑公园、意大利基安蒂雕塑公园、法国贝丁顿雕塑花园、拉脱维亚佩德维尔露天雕塑博物馆共同发起，于2014年9月成立的一个无期限组织。长春世界雕塑园是联盟的首任轮值主席单位，也是雕塑公园国际联盟第一次工作会议的承办单位。</p>
                <p>11日10时30分，雕塑公园国际联盟暨殷小烽雕塑展开幕式在长春雕塑艺术馆举行，仪式由邹德东秘书长主持，原建设部副部长宋春华、吉林省政协副主席支建华、长春市人民政府市长姜治莹、雕塑公园国际联盟成员与其他雕塑公园代表以及曾成钢、及云辉、殷小烽等国内知名艺术家出席开幕式。</p>
                <p>开幕式上，长春市副市长白绪贵先生、中国美术家协会副主席曾成钢先生、雕塑公园国际联盟代表格楚女士、著名雕塑家殷小烽先生、东北师范大学校长刘益春先生分别致辞。副市长白绪贵在开幕式上表示，联盟大会在我市召开是对长春雕塑事业发展的肯定。希望通过雕塑公园国际联盟这个平台，进一步促进长春与国际社会的友谊、交流、发展、合作，为联盟成员所在城市开展多元文化互动做出努力。开幕式上，东北师范大学美术学院副院长殷小烽将其创作的14件作品捐献给长春市人民政府，长春市市长姜治莹为殷小烽先生颁发收藏证书，最后宋春华副部长宣布雕塑展开幕。</p>
                <p>11日13时50分，雕塑公园国际联盟第一次工作会议在松山韩蓉非洲艺术收藏博物馆召开。会议由长春城市雕塑学会刘天府副理事长主持。联盟首任主席长春世界雕塑园园长王明山先生首先致辞并做工作总结。会上通过了雕塑公园国际联盟章程。11日15时20分，“共话雕塑公园的未来”研讨会开始。宋春华副部长在会议中做主旨演讲，与会代表逐一发言并对雕塑公园国际联盟的发展前景以及如何进一步扩大联盟影响力等议题进行了热烈的交流与讨论。</p>
                <p>2日10时整，雕塑公园国际联盟大会在松山韩蓉非洲艺术收藏博物馆举行闭幕式，仪式由长春市人民政府（侨务）外事工作办公室徐怀武副主任主持。现任联盟主席长春世界雕塑园园长王明山先生致辞并向本次新入盟的六个成员：美国雕塑庭园、美国苏沃特·强生工作室、台湾朱铭美术馆、美国新奥尔良雕塑公园、波士顿雕塑家艺术馆、美国卡罗尔·富尔曼基金会颁发证书。会上宣布瑞士圣·乌尔班雕塑公园创始人和合伙人格楚女士任下一届联盟主席。11时整，雕塑公园国际联盟第一次工作会议顺利完成了预定的各项议程，为期两天的雕塑公园国际联盟大会正式闭幕。</p>
                <p>在本次雕塑公园国际联盟大会期间，与会代表肩负各自园区的重托，以高度的责任感和主人翁精神，忠实履行职责，共商雕塑联盟发展大计。本次联盟大会的成功举办，必将推动现代雕塑艺术在中国的深入开展，也将成为联系中外雕塑艺术的桥梁与纽带，对中国雕塑事业的发展具有重要意义。</p>
                <h4>长春世界雕塑园</h4>
                <h4>2016年1月13日</h4>
                <div class="three_imgs">
                    <div class="img_box">
                        <img src="../assets/img/meeting15.jpg" alt="">
                    </div>
                    <div class="img_box">
                        <img src="../assets/img/meeting16.jpg" alt="">
                    </div>
                    <div class="img_box">
                        <img src="../assets/img/meeting17.jpg" alt="">
                    </div>
                </div>
                <div class="three_imgs">
                    <div class="img_box">
                        <img src="../assets/img/meeting18.png" alt="">
                    </div>
                    <div class="img_box">
                        <img src="../assets/img/meeting19.jpg" alt="">
                    </div>
                    <div class="img_box">
                        <img src="../assets/img/meeting10.jpg" alt="">
                    </div>
                </div>
                <h2>雕塑公园国际联盟第一次会议决议</h2>
                <p>雕塑（馆）公园国际联盟（以下简称雕塑公园国际联盟）第一次会议于2016年1月11日在中国长春世界雕塑园召开。雕塑公园国际联盟成员和有关雕塑公园代表嘉宾出席了会议。</p>
                <p>雕塑公园国际联盟第一次会议举行了开幕式，原中国住建部副部长宋春华、长春市市长姜治莹及有关方面负责人出席。长春市副市长白绪贵,雕塑公园国际联盟新一届轮值主席、瑞士圣乌尔班雕塑公园创始人格楚·艾希莉曼分别致辞。</p>
                <p>会议听取了首届雕塑公园国际联盟轮值主席、长春世界雕塑园园长王明山所做的工作报告，充分肯定了联盟成立以来卓有成效的工作。</p>
                <p>会议审议通过了《雕塑公园国际联盟章程》；推选瑞士圣乌尔班雕塑公园创始人格楚·艾希莉曼为新一届雕塑公园国际联盟轮值主席。会议一致同意接纳美国雕塑庭园、美国波士顿雕塑家艺术馆、美国新奥尔良雕塑公园、台湾朱铭美术馆等4个雕塑公园为雕塑公园联盟新成员。</p>
                <p>会议举行了《共话雕塑公园未来》的专题研讨，原中国住建部副部长宋春华作了世界雕塑《今日已多姿，明朝更美丽》的主旨演讲；中国长春世界雕塑园园长王明山、美国雕塑庭园执行总监盖里·施耐德、国际雕塑协会董事会成员卡罗尔·富尔曼、台湾朱铭美术馆馆长吴顺令、拉脱维亚佩德尔露天雕塑博物馆劳拉·米格隆、波士顿雕塑家艺术馆艺术家，安迪·莫尔林恩、瑞士圣乌尔班雕塑公园创始人和合伙人，格楚·艾希莉曼、新奥尔良雕塑公园艺术家迈克尔·曼哲瑞思分别就雕塑联盟成员互惠互利、雕塑文化之旅、雕塑公园旅游开发前景、国际联盟与雕塑公园如何共同发展、启动雕塑精品展览、扩大雕塑公园的影响力等进行了专题发言，形成了共识，研究探讨了雕塑公园国际联盟发展大计。</p>
                <p>会议代表还参观考察了长春世界雕塑园、中国著名雕塑家殷小烽作品展和松山韩蓉非洲艺术收藏博物馆。</p>
                <p>会议明确了雕塑公园国际联盟的宗旨是联络世界各地的雕塑公园，促进公园间友好交流、国际合作、健康发展。雕塑公园国际联盟在开展活动时，应充分考虑不同国家的各自特点，尊重不同国家的法律、法规和文化理念。</p>
                <p>会议指出，新一届轮值主席格楚·艾希莉曼在会议结束时的讲话，指明了雕塑公园国际联盟发展方向，希望发挥国际联盟优势，促进雕塑公园健康发展，提出了任期内工作要求，各成员要认真研究落实。</p>
                <p>会议强调，雕塑公园国际联盟成员自觉遵守联盟章程，认真履行成员的职责和义务，结合各自实际完成联盟会议赋予的相关任务。要加强联盟成员之间沟通联系，建设雕塑公园国际联盟网站。积极推荐、鼓励和支持新成员自愿入盟，不断扩大联盟影响力。</p>
                <p>会议要求，加强联盟秘书处工作，建立健全联盟会议及有关工作的规则和制度，确保联盟工作正常开展。</p>
                <p>会议动员雕塑公园国际联盟成员要充分发挥联盟的纽带和桥梁作用，进一步扩大交流、精诚合作、互惠互利、同舟共济，为促进雕塑公园健康发展，繁荣世界雕塑文化做出应有贡献。</p>
            </div>
        </el-tab-pane> -->
        <!-- <el-tab-pane >
            <div class="meeting_content">
                <h2>雕塑园（馆）国际联盟第二次工作会议暨“接纳·互联·传播”</h2>
                <h2>雕塑园（馆）国际联盟论坛纪要</h2>
                <div class="two_imgs">
                    <div class="two_img_item">
                        <img src="../assets/img/meeting21.jpg" alt />
                    </div>
                    <div class="two_img_item">
                        <img src="../assets/img/meeting22.jpg" alt />
                    </div>
                </div>
                <p>2017年9月8日，雕塑园（馆）国际联盟第二次工作会议在长春世界雕塑园·长春雕塑艺术馆举行。</p>
                <p>1、我们进行了雕塑园（馆）国际联盟展览馆开馆仪式。联盟展馆共计收藏了来自8家联盟成员捐赠的雕塑作品、纪念品、书籍、学术材料40余件。</p>
                <p>2、会议听取了格楚主席关于雕塑园（馆）国际联盟的国际注册情况的介绍以及《雕塑园（馆）国际联盟章程》的释义。</p>
                <p>3、12家新成员的代表向联盟委员会递交了《申请加入雕塑园（馆）国际联盟表》。</p>
                <p>会议对“雕塑园（馆）国际联盟价值观”、“雕塑园（馆）国际联盟运营模式”、“设立雕塑园（馆）国际联盟专家组”、“雕塑园（馆）国际联盟网站”、“雕塑园（馆）国际联盟成员单位所在国驻华大使馆联络机制”、“雕塑园（馆）国际联盟2018年委员会会议”等议题进行了详细而全面的探讨。</p>
                <p>与会人员对上述议题达成初步共识，并表示将为雕塑园（馆）国际联盟的健康、有序、良好发展贡献出自己的力量。</p>
                <div class="three_imgs">
                    <div class="img_box">
                        <img src="../assets/img/meeting23.jpg" alt="">
                    </div>
                    <div class="img_box">
                        <img src="../assets/img/meeting24.jpg" alt="">
                    </div>
                    <div class="img_box">
                        <img src="../assets/img/meeting25.jpg" alt="">
                    </div>
                </div>
                <div class="two_imgs">
                    <div class="two_img_item">
                        <img src="../assets/img/meeting29.jpg" alt />
                    </div>
                    <div class="two_img_item">
                        <img src="../assets/img/meeting30.jpg" alt />
                    </div>
                </div>
                <div class="three_imgs">
                    <div class="img_box">
                        <img src="../assets/img/meeting26.jpg" alt />
                    </div>
                    <div class="img_box">
                        <img src="../assets/img/meeting27.jpg" alt />
                    </div>
                    <div class="img_box">
                        <img src="../assets/img/meeting28.jpg" alt />
                    </div>
                </div>
                <div class="two_imgs">
                    <div class="two_img_item">
                        <img src="../assets/img/meeting31.jpg" alt />
                    </div>
                    <div class="two_img_item">
                        <img src="../assets/img/meeting32.png" alt />
                    </div>
                </div>
            </div>
        </el-tab-pane> -->

      </el-tabs>
    </div>
  </div>
</template>

<script>
import videoPoster from "@/assets/img/meeting_video.png";
import { info,getByNav } from '../api/api'
export default {
  name: "company",
  data() {
    return {
        title:'',
        img:'',
        playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "http://192.144.163.183:8066/mp4.mp4", //url地址
          },
        ],
        poster: videoPoster, //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },
  computed: {
	chOrEn(){
		return sessionStorage.getItem('chOrEn')
	}
  },
    created(){
        // alert(1)
        // debugger
		let chOrEn = this.$route.query.chOrEn
		if(!chOrEn){
			    this.$router.push({
			    path: '/aboutAlliances',
			    })
		}else{
			chOrEn === '0' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'zh';
			sessionStorage.setItem('lang',this.$i18n.locale)
			sessionStorage.setItem('chOrEn',chOrEn)
		}
        let navigationId = {
            id:this.$route.query.list
        }
        info({...navigationId}).then(res=>{
            this.title=res.data.data.content
            // this.list=[]
            // this.num = res.data.page.total
            // this.list = res.data.page
        })
        let getBynavid = {
            navigationId:4
        }
        getByNav({...getBynavid}).then(res=>{
            this.img = res
        })
    },
  methods:{
     go(){
         this.$router.go(-1)
     },
     gos(){
         this.$router.push('/home')
     }
  }
};
</script>

<style lang="less" scoped>
.banner_img{
    height:400px
}
    #pointer {
    //   width: 200px;
        height: 40px;
        color: #FFFFFF;
        position: relative;
        font-weight: 400;
        background: #CFCFCF;
        font-size: 18px;
        line-height: 25px;
        padding:2px 30px 2px 15px;
        display: flex;justify-content: flex-start;align-items:center;
    }
    #pointers {
    //   width: 200px;
        height: 40px;
        color: #FFFFFF;
        position: relative;
        font-weight: 400;
        background: #2539B4;
        font-size: 18px;
        line-height: 25px;
        padding:2px 30px 2px 15px;
        display: flex;justify-content: flex-start;align-items:center;
    }
    #pointer:before {
      content: "";
      position: absolute;
      right: -0px;
      bottom: 0;
      width: 0;
      height: 0;
      margin-left:3px;
      border-right: 20px solid white;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }
    #pointers:before {
      content: "";
      position: absolute;
      left: -20px;
      bottom: 0;
      width: 0;
      height: 0;
      border-right: 20px solid #2539B4;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }

    #pointers:after {
      content: "";
      position: absolute;
      right: 0;
      bottom: 0;
      width: 0;
      height: 0;
      border-right: 20px solid white;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }
    #pointerss {
      width: 5px;
      height: 40px;
      position: relative;
      background: #CFCFCF;
    }
    #pointerss:after {
      content: "";
      position: absolute;
      right: 0;
      bottom: 0;
      width: 0;
      height: 0;
      border-right: 20px solid white;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }
    #pointerss:before {
      content: "";
      position: absolute;
      left: -20px;
      bottom: 0;
      width: 0;
      height: 0;
      border-right: 20px solid #CFCFCF;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }
    #pointersss {
      width: 5px;
      height: 40px;
      position: relative;
      background: #CFCFCF;
    }
    #pointersss:after {
        content: "";
      position: absolute;
      right: 0;
      bottom: 0;
      width: 0;
      height: 0;
      border-right: 20px solid white;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }
    #pointersss:before {
        content: "";
      position: absolute;
      left: -20px;
      bottom: 0;
      width: 0;
      height: 0;
      border-right: 20px solid #CFCFCF;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }
    #pointerssss {
        width: 0px;
        height: 40px;
        position: relative;
        background: #CFCFCF;
    }
    #pointerssss:after {
        content: "";
      position: absolute;
      right: 0;
      bottom: 0;
      width: 0;
      height: 0;
      border-right: 20px solid #CFCFCF;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }
    // #pointer:before {
    //     content: "";
    //     position: absolute;
    //     right: -20px;
    //     bottom: 0;
    //     width: 0;
    //     height: 0;
    //     border-left: 20px solid red;
    //     border-top: 20px solid transparent;
    //     border-bottom: 20px solid transparent;
    // }
.about_alliances {
  width: 100%;
//   height: 100%;
  /deep/ .el-tabs__item {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .second_main{
      .meeting_content{
          .three_imgs{
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-between;
            margin:10px 0;
            .img_box{
                width: 266px;
                height: 182px;
                overflow: hidden;
                cursor: pointer;
                img{
                    width: 100%;
                    height: 100%;
                    transition: all 1s ease;
                }
                img:hover{
                    transform: scale(1.2);
                }
            }
          }
          .two_imgs{
              display: flex;
              justify-content: space-between;
              margin:15px 0 ;
               .two_img_item{
                    width: 400px;
                    height: 280px;
                    overflow: hidden;
                cursor: pointer;
                    img{
                        width: 100%;
                        height: 100%;
                         transition: all 1s ease;
                    }
                    img:hover{
                    transform: scale(1.2);
                }
            }
          }
          h4{
              text-align: right;
              font-size: 14px;
              color: #606060;
              line-height: 30px;
          }
          h2{
              font-size: 18px;
              line-height: 50px;
              text-align: center;
              color: #2F2F2F;
              font-weight: 700;
          }
      }
      
  }
}
.datail /deep/ img{
    width: 100%;
    
}
.datail /deep/ video{
    width: 100%;
	height: auto;   
}
</style>